import { render, staticRenderFns } from "./recipients-create-edit-page.vue?vue&type=template&id=9f47db30&"
import script from "./recipients-create-edit-page.vue?vue&type=script&lang=js&"
export * from "./recipients-create-edit-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports